// تسجيل Service Worker للإنتاج فقط، مع منع حلقة إعادة التحميل:
// - `controllerchange` يُطلق أيضاً عند أول سيطرة للـ SW على صفحة غير مُدارة (clients.claim)،
//   فكانت الصفحة تُعاد تحميلها ثم يُعاد تسليح المستمع → تحميل متكرر. الآن نُعيد التحميل فقط
//   إذا كان هناك SW مُسيطر أصلاً عند فتح الصفحة (أي تحديث حقيقي لنسخة الكود).
// - وحتى في التحديث الحقيقي: مرة واحدة فقط لكل جلسة متصفح (علم في sessionStorage).
// - فحص التحديث كل 30 دقيقة بدل كل دقيقة.
const RELOAD_KEY = "helcoo_sw_reloaded";
const CHECK_MS = 30 * 60_000;

const clearAll = () => {
  navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister())).catch(() => {});
  if (window.caches) caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
};

export const registerServiceWorker = () => {
  if (!("serviceWorker" in navigator)) return;

  // داخل تطبيق الجوال (Capacitor) وفي بيئة التطوير: لا SW إطلاقاً، ونُلغي أي بقايا قديمة.
  const native = window.Capacitor?.isNativePlatform?.() === true;
  if (native || process.env.NODE_ENV !== "production") {
    clearAll();
    return;
  }

  const hadController = !!navigator.serviceWorker.controller;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { updateViaCache: "none" })
      .then((reg) => setInterval(() => reg.update(), CHECK_MS))
      .catch(() => {});
  });

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hadController || sessionStorage.getItem(RELOAD_KEY) === "1") return;
    sessionStorage.setItem(RELOAD_KEY, "1");
    window.location.reload();
  });
};
